import React, { useEffect,useState} from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

// Local component import
import ClientData from './ClientData';
import OrderData from './OrderData';

import * as Style from './style';
import api from '~/services/api';

const getClientData = async (order) => {
    const res = await api.post(
                `salesperson/orders/client-data`,
                {
                    orderData: [{
                        orderId:order.orderId,
                        clientId:order.clientId
                    }],
                }
            );
    return res.data?.[0] || {};
}

function ListItem({ order:orderParam, multimarca, setCurrentPage }) {
    const history = useHistory();
    const location = useLocation().pathname;
    const [order, setOrder] = useState(orderParam);

    const getPackageId = () => {
        if (order.idPacote) {
            return `${order.idPacote}`;
        }
        return '';
    };

    useEffect(() => {
        const fetchClientData = async () => {
            const data = await getClientData(order);

            const newFormattedOrder = {
                ...order,
                clientData: data.clientData,
            };

            setOrder(newFormattedOrder);
        };
        fetchClientData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const handleClick = () => {
        const isCancelled = order?.status_evento === "CANCELADO" ? "&isCancelled=true" : "";        
        const getMomentQuery = moment
            .utc(order?.creationDate)
            .format('YYYY-MM-DD');

        const omniMomentQuery = moment
            .utc(order?.invoicedDate)
            .format('YYYY-MM-DD');

        const packageId = getPackageId();

        if (location === '/storeOmni') {
            history.push({
                pathname: `/detailOrder/${order?.orderId}/${order?.salesCode}/${omniMomentQuery}/${packageId}${isCancelled}${order?.brandId ? `?brands=${order?.brandId}` : ''}`,
                state: { order },
            });
            return;
        }
        if (location === '/maisCarrinho') {
            setCurrentPage(order)
            return;
        }

        history.push(
            `/detailOrder/${order?.orderId}/${order?.vendedor}/${getMomentQuery}/${packageId}${isCancelled}${order?.brandId ? `?brands=${order?.brandId}` : ''}`
        );
    };

    return (
        <Style.ListItemContainer onClick={() => handleClick()}>
            <Style.ListItemContainerGrid>
                <ClientData order={order} multimarca={multimarca} />
                <OrderData order={order} />
            </Style.ListItemContainerGrid>
        </Style.ListItemContainer>
    );
}

export default ListItem;
